<template>
    <div class="card statistic-table">
        <div class="card-header">
            {{ title }}
        </div>
        <div class="card-block">
            <div :id="`chart-container-${id}`"></div>
        </div>
    </div>
</template>

<script>
  import Highcharts from 'highcharts'
  import Highmaps from 'highcharts/modules/map'

  Highmaps(Highcharts)

  export default {
    props: {
      statistic: {
        required: true
      },
      title: {
        required: true
      },
      id: {
        required: true
      }
    },
    name: 'OperatorActivityChart',
    mounted () {
      Highcharts.chart(`chart-container-${this.id}`, this.chartConfig)
    },
    computed: {
      chartConfig () {
        return {
          chart: {
            type: 'heatmap',
            inverted: true
          },
          title: {
            text: null
          },
          subtitle: {
            text: null
          },
          credits: {
            enabled: false
          },
          xAxis: {
            type: 'datetime',
            labels: {
              format: '{value:%Y-%m-%d}'
            },
            tickWidth: 1,
            tickPixelInterval: 30,
            gridLineWidth: 15,
            breakSize: 0
          },
          yAxis: {
            title: {
              text: null
            },
            labels: {
              format: '{value}:00'
            },
            minPadding: 0,
            maxPadding: 0,
            startOnTick: false,
            endOnTick: false,
            tickPositions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
            tickWidth: 1,
            min: 0,
            max: 23
          },
          colorAxis: {
            stops: [
              [0, '#78c439'],
              [0.5, '#FFFF00'],
              [1, '#c4463a']
            ],
            min: 0
          },
          series: [{
            borderWidth: 1,
            borderColor: 'white',
            colsize: 16 * 36e5, // one day
            tooltip: {
              headerFormat: `${this.$t('statistic.actions')}<br/>`,
              pointFormat: '{point.x:%Y-%m-%d} {point.y}:00: <b>{point.value}</b>'
            },
            data: this.statistic
          }]
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// OperatorActivityChart.vue?201f3f96